import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { DynamicComponentObject } from '../../../dynamic-components/interfaces/dynamic-component-object';
import { DynamicFormElementEl } from '../../interfaces/fields-components';
import { FormAllData } from '../../interfaces/forms/form-element';
import { fieldTypeComponents } from '../../models/field-model';
@Pipe({
    name: 'dynCompConverter',
    standalone: false
})
export class DynCompConverterPipe implements PipeTransform {
  transform(
    value: FormAllData,
    data: DynamicFormElementEl
  ): DynamicComponentObject<{
    field: FormAllData;
    formGroup: FormGroup;
    stepName?: string;
  }> {
    return {
      component: fieldTypeComponents[value.typeInterface],
      data: {
        field: value,
        formGroup: data.formGroup as FormGroup,
        stepName: data.stepName,
      },
    };
  }
}
